import { render, staticRenderFns } from "./Denomination.vue?vue&type=template&id=5839030b"
import script from "./Denomination.vue?vue&type=script&lang=js"
export * from "./Denomination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports